import { render, staticRenderFns } from "./retire.vue?vue&type=template&id=5cc89907&scoped=true&"
import script from "./retire.vue?vue&type=script&lang=js&"
export * from "./retire.vue?vue&type=script&lang=js&"
import style0 from "./retire.vue?vue&type=style&index=0&id=5cc89907&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc89907",
  null
  
)

export default component.exports